export const APP_REDUCER_NAME = 'appContainer';

export enum ACTIONS {
  SHOW_SIDEBAR_MENU = 'SHOW_SIDEBAR_MENU',
}
